import React, { FC } from 'react';
import { Dialog, DialogContent, Box, Typography, Grid, Button } from '@mui/material';
import AccessTime from '@mui/icons-material/AccessTime';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  orderStatus?: string;
  setCurrentModalState: (currentModalState: string) => void;
};

export const OtherView: FC<Props> = ({ isOpen, onClose, orderStatus, setCurrentModalState }) => {
  const handleClose = () => {
    setCurrentModalState('');
    onClose();
  };

  return (
    <Dialog open={isOpen} fullWidth maxWidth="xs">
      <Box display="flex" alignItems="center" flexDirection="row" px={2} pt={3} justifyContent="center">
        <AccessTime color="warning" sx={{ fontSize: '40px' }} style={{ marginRight: '10px' }} />
        <Typography variant="h3">{(orderStatus = 'Declined' ? 'ORDER NOT PROCESSED' : '')}</Typography>
      </Box>
      <DialogContent>
        <Grid container spacing={2} display="flex" alignItems="center" justifyContent="center" flexDirection="column">
          <Grid item xs={12}>
            <Typography variant="subtitle1" data-testid="order-status-other-text">
              Your order is - {orderStatus}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Button variant="outlined" onClick={handleClose}>
              Close
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
